import { UserButton } from "@clerk/react";

export function NotProvisioned() {
  return (
    <div className="h-screen flex flex-col bg-background">
      <header className="shrink-0 border-b border-border">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <h1 className="text-lg font-semibold tracking-tight text-foreground font-sans">
            AlwaysAI
          </h1>
          <UserButton />
        </div>
      </header>
      <main className="flex-1 flex items-center justify-center">
        <div className="max-w-md text-center px-4">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--color-warning-soft)]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="var(--color-warning)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-foreground font-sans mb-2">
            Your account is being set up
          </h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Your login was successful, but your account hasn&apos;t been
            provisioned yet. Please contact your admin to complete setup.
          </p>
        </div>
      </main>
    </div>
  );
}
